import { useState } from 'react';
import { api } from '../../lib/api';
import { T, useGym } from '../../lib/gym';
import { useI18n } from '../../lib/i18n';
import { AsyncButton, Card, errorText, Input, PageHeader } from '../../ui/components';

const SUGGESTIONS = ['q_quiet_slots', 'q_at_risk', 'q_revenue', 'q_trials', 'q_next_step'];

/** Asks questions about this gym's own figures; the answer only uses data from the reports. */
export function AssistantPage() {
  const gym = useGym();
  const i18n = useI18n();
  const [question, setQuestion] = useState('');
  const [thread, setThread] = useState<{ q: string; a: string; note?: string }[]>([]);

  const ask = async (text: string): Promise<void> => {
    const q = text.trim();
    if (!q) return;
    setQuestion('');
    try {
      const r = await api(`${T(gym.slug)}/admin/assistant`, { body: { question: q } });
      setThread((t) => [{ q, a: r.answer, note: r.note }, ...t]);
    } catch (e) {
      setThread((t) => [{ q, a: errorText(e, i18n) }, ...t]);
    }
  };

  return (
    <div className="page narrow">
      <PageHeader title={i18n.t('assistant.title')} subtitle={i18n.t('assistant.subtitle')} />
      <Card>
        <form className="row gap-sm" onSubmit={(e) => { e.preventDefault(); void ask(question); }}>
          <Input value={question} placeholder={i18n.t('assistant.placeholder')} onChange={(e) => setQuestion(e.target.value)} />
          <AsyncButton disabled={!question.trim()} onClick={() => ask(question)}>{i18n.t('assistant.ask')}</AsyncButton>
        </form>
        <div className="row gap-sm wrap">
          {SUGGESTIONS.map((k) => (
            <button type="button" key={k} className="chip" onClick={() => ask(i18n.t(`assistant.${k}`))}>{i18n.t(`assistant.${k}`)}</button>
          ))}
        </div>
      </Card>
      {thread.map((item, i) => (
        <Card key={i} title={item.q}>
          <p className="pre">{item.a}</p>
          {item.note === 'no_language_model' && <p className="small muted">{i18n.t('assistant.no_model')}</p>}
          {item.note === 'language_model_failed' && <p className="small warn">{i18n.t('assistant.model_failed')}</p>}
        </Card>
      ))}
      <p className="small muted">{i18n.t('assistant.disclaimer')}</p>
    </div>
  );
}
